/**
 * Router Registry - A singleton to hold router instance
 * This avoids circular dependency issues when importing router
 */

let routerInstance: any = null
let routeInstance: any = null

export const RouterRegistry = {
  setRouter(router: any) {
    routerInstance = router
  },
  
  getRouter() {
    if (!routerInstance) {
      console.warn('Router not yet registered. Make sure to call RouterRegistry.setRouter() during app initialization.')
    }
    return routerInstance
  },

  setRoute(route: any) {
    routeInstance = route
  },

  getRoute() {
    return routeInstance
  },

  // Helper to get current route from router
  getCurrentRoute() {
    return routerInstance?.currentRoute
  }
}

